// extracted by mini-css-extract-plugin
module.exports = {"content":"_7c036fed","expanded":"_ff066ae3"};